import axios from 'axios';
import { REACT_APP_API } from '../../config';
  
export default async function getExposureTypes(accountId) {

  try {
    const res = await axios.get(`${REACT_APP_API}/publications/meli/expositionTypes/${accountId}`)
    return res.data
  } catch (error) {
    if(error?.response?.data?.message) error.message = error.response.data.message;
    throw error;
  }
  
}
